import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

interface IAnnualRevenueChartProps {
  data: { date: string; final_value: number }[];
}

const AnnualRevenueChart: React.FC<IAnnualRevenueChartProps> = ({ data }) => {
  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  };

  const groupDataByYear = (data: { date: string; final_value: number }[]) => {
    const groupedData: Record<string, number> = {};
    
    data.forEach(item => {
      const [_, year] = item.date.split("/");
      groupedData[year] = (groupedData[year] || 0) + item.final_value;
    });
    
    return groupedData;
  };

  const annualData = groupDataByYear(data);
  const years = Object.keys(annualData).sort();
  const values = years.map(year => annualData[year]);

  const chartData = {
    labels: years,
    datasets: [{
      label: "Receita Anual",
      data: values,
      backgroundColor: "rgb(100, 151, 232)",
      borderColor: "rgb(100, 151, 232)",
      borderWidth: 1,
      barPercentage: 0.6,
      overflow:"hidden"
    }]
  };

  const isMobile = window.innerWidth < 600;
  const isLargeScreen = window.innerWidth > 1200;

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: (value: string | number) => formatCurrency(Number(value)),
          maxTicksLimit: 6
        }
      },
      x: {
        grid: { 
          display: false 
        },
        ticks: {
          autoSkip: true,
          maxRotation: 45,
          minRotation: 45,
          font: {
            size: isMobile ? 10 : 12
          }
        }
      }
    },
    plugins: {
      legend: { 
        display: false 
      },
      tooltip: {
        callbacks: {
          label: (context: any) => formatCurrency(context.raw)
        },
        bodyFont: {
          size: isMobile ? 12 : 14
        }
      }
    }
  };

  return (
    <div style={{ 
      width: '100%', 
      height: isMobile ? '200px' : isLargeScreen ? '250px' : '300px',
      padding: '8px',
      marginBottom: isMobile ? '16px' : '24px',
      overflow:"hidden"
    }}>
      <Bar 
        data={chartData}
        options={chartOptions}  />
    </div>
  );
};

export default AnnualRevenueChart;